<template>
    <div>
        <div class="Form__group">
            <label for="make" class="Form__label">Make</label>
            <multiselect v-model="make"
                         :options="makes"
                         trackBy="code"
                         label="name"
                         :hideSelected="true"
                         placeholder="Select Model"
                         @input="loadRanges"
            >
            </multiselect>
        </div>

        <div class="Form__group" v-show="hasRanges">
            <label for="range" class="Form__label">Model</label>
            <multiselect v-model="range"
                         :options="ranges"
                         :hideSelected="true"
                         :options-limit="999999999999999999999"
                         placeholder="Select Range"
                         @input="loadModels"
            >
            </multiselect>
        </div>

        <div class="Form__group" v-show="hasModels && hasRanges">
            <label for="model" class="Form__label">Model Variant</label>
            <multiselect :value="model"
                         :options="models"
                         :hideSelected="true"
                         :options-limit="999999999999999999999"
                         placeholder="Select Model"
                         @input="loadMatches"
            >
            </multiselect>
        </div>

        <table class="Table" v-show="hasMatches">
            <tr>
                <th>Stat Code</th>
                <th>Model Variant</th>
                <th>CO<sub>2</sub> (g/km)</th>
                <th>Engine Capacity</th>
                <th>Fuel Grade</th>
            </tr>
            <tr v-for="model in matches">
                <td>{{ model.stat_code }}</td>
                <td>{{ model.name }}</td>
                <td>{{ model.co2 }}</td>
                <td>{{ model.engine_capacity }}</td>
                <td class="Table__cell--min-width" style="width: 20%;">
                    <form action="/co2/download" method="POST" @submit.prevent="download($event)">
                        <input name="_token" type="hidden" :value="csrfToken">
                        <input type="hidden" name="stat_code" :value="model.stat_code">

                        <div style="display: flex; justify-content: space-between; align-items: center;">
                            <div class="Form__select" style="margin-right: 10px">
                                <select name="fuel_type_id">
                                    <option value="">Please Select</option>
                                    <option :value="type.id" v-for="type in fuelTypes">{{ type.name }}</option>
                                </select>
                            </div>

                            <input type="submit" value="Download Label" class="Button">
                        </div>
                    </form>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'

    export default {
        data() {
            return {
                csrfToken: Laravel.csrfToken,
                make: '',
                range: '',
                model: '',
                ranges: [],
                models: [],
                matches: []
            }
        },

        props: ['makes', 'fuelTypes'],

        computed: {
            hasRanges() {
                return ! _.isEmpty(this.ranges);
            },

            hasModels() {
                return ! _.isEmpty(this.models);
            },

            hasMatches() {
                return ! _.isEmpty(this.matches);
            }
        },

        methods: {
            loadRanges() {
                this.resetRanges();

                this.$http.post('/co2/ranges', { make: this.make.code }).then((response) => {
                    this.ranges = response.data;
                })
            },

            loadModels() {
                this.resetModels();

                this.$http.post('/co2/models', { make: this.make.code, range: this.range }).then((response) => {
                    this.models = response.data;
                })
            },

            loadMatches(model) {
                this.model = model;
                this.matches = [];

                this.$http.post('/co2/models/matches', { make: this.make.code, range: this.range, model: this.model }).then((response) => {
                    this.matches = response.data;
                })
            },

            resetRanges() {
                this.range = '';
                this.ranges = [];

                this.resetModels();
            },

            resetModels() {
                this.model = '';
                this.models = [];
                this.matches = [];
            },

            download(e) {
                if (e.target.querySelector('[name="fuel_type_id"]').value === '') {
                    e.target.querySelector('.Form__select').classList.add('Form__select--has-error');

                    return false;
                }

                try {
                    ga('send', {hitType: 'event',eventCategory: 'Used/Derogated',eventAction: 'Click',eventLabel: 'Download Label'});
                } catch (e) {
                    console.log('MOCK GA EVENT');
                }

                e.target.querySelector('.Form__select').classList.remove('Form__select--has-error');
                e.target.submit();
            }
        },

        components: {
            Multiselect,
        }
    }
</script>